import * as React from 'react';
import {FieldData} from 'src/app/model/lighthouse/Common';
import FieldRenderer from 'src/app/component/lighthouse/review/FieldRenderer';

export interface AuditChecksSectionProps {
    /** Array of audit check fields the auditor must respond to. */
    fields: FieldData[];
    /** Callback fired when an auditor changes a field value (label → new value). */
    onChange?: (label: string, value: string) => void;
}

/**
 * Renders the "Audit Checks" section of the Lighthouse Review page.
 * Unlike CaseDetails and DataPoints, this section is editable — auditors
 * fill in their responses (radio buttons, dropdowns, freeform, etc.).
 * The parent page collects these via onChange to build auditCheckResponses
 * for the SubmitDecisionRequest.
 */
const AuditChecksSection: React.FC<AuditChecksSectionProps> = ({fields, onChange}) => {
    const hasFields = Array.isArray(fields) && fields.length > 0;

    return (
        <div className="lighthouse-section" data-testid="audit-checks-section">
            <div className="lighthouse-section-title">Audit Checks</div>
            {hasFields ? (
                <div className="lighthouse-section-content">
                    {fields.map(field => (
                        <FieldRenderer
                            key={field.label}
                            field={field}
                            readOnly={false}
                            onChange={onChange}
                        />
                    ))}
                </div>
            ) : (
                <div className="lighthouse-section-empty" data-testid="audit-checks-empty">
                    No audit checks available.
                </div>
            )}
        </div>
    );
};

export default AuditChecksSection;
